import React, { useState, useEffect } from "react";
import { Route, Redirect, RouteProps, useLocation } from "react-router-dom";
import { useUserContext } from "../contexts/UserContext";

interface EmailRouteProps extends RouteProps {
  component: React.ComponentType<any>;
  message?: string;
}

const EmailRoute: React.FC<EmailRouteProps> = ({
  component: Component,
  message = "You are not logged in.",
  ...rest
}) => {
  const { user } = useUserContext();
  const location = useLocation();
  const [countdown, setCountdown] = useState(5);
  const [redirectNow, setRedirectNow] = useState(false);

  useEffect(() => {
    if (!user) {
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setRedirectNow(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [user]);

  if (user) {
    return <Route {...rest} render={(props) => <Component {...props} />} />;
  }

  if (redirectNow) {
    return (
      <Redirect
        to={{
          pathname: "/login",
          state: { from: location },
        }}
      />
    );
  }

  return (
    <div style={{ textAlign: "center", marginTop: "20vh", fontSize: "28px" }}>
      <p>{message}</p>
      <p style={{ fontSize: "18px" }}>
        Redirecting to login page in {countdown} second{countdown !== 1 ? "s" : ""}...
      </p>
    </div>
  );
};

export default EmailRoute;

